import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { PhysicalAccountId, PortfolioPlanAssignmentId, SecurityId, VirtualAccountId, } from "../../Types";
import ValidationError from "../../ZodError";
import { PersonId } from "../types";
export const excludedAssetsURL = (abstractPortfolioId, concretePortfolioId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${abstractPortfolioId}/assignment/${concretePortfolioId}/excluded-assets`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${abstractPortfolioId}/assignment/${concretePortfolioId}/excluded-assets`;
const ExcludedSecuritySchema = z.object({
    securityId: SecurityId,
    concreteImplementationPlanId: PortfolioPlanAssignmentId,
    physicalAccountId: PhysicalAccountId,
    virtualAccountId: VirtualAccountId,
    createdAt: z
        .string()
        .transform((str) => new Date(str))
        .optional(),
    createdBy: PersonId.nullable().optional(),
});
export const ExcludedAssetsResponse = z.object({
    data: z.array(ExcludedSecuritySchema),
});
export const getExcludedAssets = async (abstractPortfolioId, concretePortfolioId, config) => {
    const { data } = await axios.get(excludedAssetsURL(abstractPortfolioId, concretePortfolioId), {
        headers: {
            version: "20250404",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = ExcludedAssetsResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    const errorMessage = `[getExcludedAssets.ts] received unexpected data`;
    errorLog(errorMessage, decoded.error.message);
    throw new ValidationError(errorMessage, decoded.error.issues);
};
//# sourceMappingURL=getExcludedAssets.js.map